import request from "@/utils/request";

export function addressAdd(params = {}) {
  return request({
    method: "post",
    url: "/address/add/",
    data: params
  });
}

export function addressHistory(params = {}) {
  return request({
    method: "get",
    url: `/address/history/`,
    data: params
  });
}

export function addressList(params = {}) {
  return request({
    method: "get",
    url: `/address/list/`,
    data: params
  });
}